// svg polyfill for better xlink support
var svg4everybody = require('svg4everybody');
svg4everybody();

// outline.js
require('./util/_outline.js');

// automatically require all modules
require('./modules/_expand.js');require('./modules/_flextabs.js');require('./modules/_header.js');require('./modules/_minimodal.js');require('./modules/_photo-nav.js');require('./modules/_testimonials.js');
